import { useState, useEffect } from "react";
import { getAllApplications } from "../../services/api";
const BASE = "https://imalishawelfare.com/api";

export default function Communications() {
  const [apps, setApps] = useState([]);
  const [selected, setSelected] = useState(null);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [tab, setTab] = useState("compose");

  useEffect(()=>{ getAllApplications().then(setApps).catch(()=>{}); }, []);

  const templates = [
    { name:"Approval + Credentials", subject:"Your Loan Application Has Been Approved", body:"Dear {name},\n\nWe are pleased to inform you that your loan application has been approved.\n\nPlease log in to your portal to view your loan offer and select your preferred amount.\n\nLogin: https://imalishawelfare.com/login\n\nRegards,\nImalisha Welfare Loan Programme" },
    { name:"Rejection Notice", subject:"Update on Your Loan Application", body:"Dear {name},\n\nThank you for applying to the Imalisha Welfare Loan Programme.\n\nAfter careful review, we regret to inform you that your application was not successful at this time.\n\nYou may re-apply after 3 months with updated documentation.\n\nRegards,\nImalisha Welfare Loan Programme" },
    { name:"Document Request", subject:"Additional Documents Required", body:"Dear {name},\n\nThank you for your loan application.\n\nWe require additional documents to process your application. Please submit the following:\n\n1. Clear copy of your National ID (front and back)\n2. Recent passport photo\n\nPlease visit our office or reply to this email.\n\nRegards,\nImalisha Welfare Loan Programme" },
    { name:"Loan Disbursement", subject:"Your Loan Has Been Disbursed", body:"Dear {name},\n\nYour loan has been successfully disbursed to your registered payment method.\n\nPlease log in to your portal to view the transaction details.\n\nRemember to make your repayments on time.\n\nRegards,\nImalisha Welfare Loan Programme" },
    { name:"Reminder � Fee Payment", subject:"Action Required: Complete Your Loan Fee Payment", body:"Dear {name},\n\nThis is a reminder that your loan processing fee is pending.\n\nPlease log in to your portal to complete the M-Pesa payment and receive your loan within 24 hours.\n\nLogin: https://imalishawelfare.com/login\n\nRegards,\nImalisha Welfare Loan Programme" },
  ];

  const sendEmail = async () => {
    if (!selected || !subject || !message) { alert("Please fill all fields"); return; }
    setSending(true);
    try {
      const token = sessionStorage.getItem("token");
      const app = apps.find(a=>a.id===selected);
      const body = message.replace(/\{name\}/g, app?.fullName||"Applicant");
      await fetch(`${BASE}/admin/send-email`, {
        method:"POST",
        headers:{ "Authorization":"Bearer "+token, "Content-Type":"application/json" },
        body: JSON.stringify({ email:app?.email, subject, message:body }),
      });
      setSent(true);
      setTimeout(()=>setSent(false), 3000);
    } catch(e) { alert("Failed to send: "+e.message); }
    finally { setSending(false); }
  };

  const resendCredentials = async (appId) => {
    if (!window.confirm("Resend login credentials to this applicant?")) return;
    try {
      const token = sessionStorage.getItem("token");
      await fetch(`${BASE}/applications/${appId}/resend-credentials`, { method:"POST", headers:{ "Authorization":"Bearer "+token } });
      alert("Credentials resent successfully!");
    } catch(e) { alert("Failed: "+e.message); }
  };

  return (
    <div>
      <div style={{ display:"flex", gap:8, marginBottom:20 }}>
        {[["compose","Compose Email"],["resend","Resend Credentials"]].map(([id,lbl])=>(
          <button key={id} onClick={()=>setTab(id)} style={{ padding:"8px 20px", borderRadius:8, border:"none", cursor:"pointer", fontSize:13, fontWeight:600, background:tab===id?"#0066cc":"white", color:tab===id?"white":"#64748b", boxShadow:"0 1px 4px rgba(0,0,0,0.08)" }}>{lbl}</button>
        ))}
      </div>

      {tab==="compose" && (
        <div style={{ display:"grid", gridTemplateColumns:"320px 1fr", gap:20 }}>
          {/* Templates */}
          <div style={{ background:"white", borderRadius:12, padding:"20px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
            <h3 style={{ fontSize:14, fontWeight:700, margin:"0 0 14px", color:"#1e293b" }}>Email Templates</h3>
            {templates.map((t,i)=>(
              <div key={i} onClick={()=>{ setSubject(t.subject); setMessage(t.body); }} style={{ padding:"10px 12px", borderRadius:8, cursor:"pointer", marginBottom:6, border:"1px solid #e2e8f0", background:"#f8fafc", fontSize:13 }}
                onMouseEnter={e=>e.currentTarget.style.background="#eff6ff"}
                onMouseLeave={e=>e.currentTarget.style.background="#f8fafc"}>
                <div style={{ fontWeight:600, color:"#1e293b" }}>{t.name}</div>
                <div style={{ fontSize:11, color:"#94a3b8", marginTop:2 }}>{t.subject.substring(0,40)}...</div>
              </div>
            ))}
          </div>

          {/* Compose */}
          <div style={{ background:"white", borderRadius:12, padding:"24px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
            <h3 style={{ fontSize:14, fontWeight:700, margin:"0 0 18px", color:"#1e293b" }}>Compose Email</h3>
            <div style={{ marginBottom:14 }}>
              <label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:.5 }}>Recipient</label>
              <select value={selected||""} onChange={e=>setSelected(Number(e.target.value))} style={{ width:"100%", padding:"10px 14px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:13 }}>
                <option value="">Select applicant...</option>
                {apps.map(a=><option key={a.id} value={a.id}>{a.fullName} � {a.email}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:.5 }}>Subject</label>
              <input value={subject} onChange={e=>setSubject(e.target.value)} placeholder="Email subject..." style={{ width:"100%", padding:"10px 14px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:13, boxSizing:"border-box" }}/>
            </div>
            <div style={{ marginBottom:18 }}>
              <label style={{ fontSize:12, fontWeight:700, color:"#475569", display:"block", marginBottom:6, textTransform:"uppercase", letterSpacing:.5 }}>Message (use {"{name}"} for applicant name)</label>
              <textarea value={message} onChange={e=>setMessage(e.target.value)} rows={10} placeholder="Type your message..." style={{ width:"100%", padding:"10px 14px", border:"1.5px solid #e2e8f0", borderRadius:8, fontSize:13, boxSizing:"border-box", resize:"vertical", fontFamily:"inherit" }}/>
            </div>
            <div style={{ display:"flex", gap:12 }}>
              <button onClick={sendEmail} disabled={sending} style={{ flex:1, padding:"11px", background:"linear-gradient(135deg,#0066cc,#0052a3)", color:"white", border:"none", borderRadius:8, fontWeight:700, fontSize:14, cursor:"pointer", opacity:sending?0.6:1 }}>
                {sending?"Sending...":sent?"Sent!":"Send Email"}
              </button>
              <button onClick={()=>{ setSubject(""); setMessage(""); setSelected(null); }} style={{ padding:"11px 20px", background:"#f1f5f9", color:"#64748b", border:"none", borderRadius:8, fontWeight:600, fontSize:13, cursor:"pointer" }}>Clear</button>
            </div>
            {sent && <div style={{ marginTop:12, padding:"10px 14px", background:"#f0fdf4", border:"1px solid #86efac", borderRadius:8, fontSize:13, color:"#16a34a", fontWeight:600 }}>Email sent successfully!</div>}
          </div>
        </div>
      )}

      {tab==="resend" && (
        <div style={{ background:"white", borderRadius:12, padding:"20px", boxShadow:"0 1px 6px rgba(0,0,0,0.06)" }}>
          <h3 style={{ fontSize:14, fontWeight:700, margin:"0 0 18px", color:"#1e293b" }}>Resend Login Credentials</h3>
          <p style={{ fontSize:13, color:"#64748b", marginBottom:18 }}>Resend login credentials to approved applicants who may have lost their password.</p>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
            <thead><tr style={{ background:"#f8fafc" }}>
              {["Name","Email","Status","Action"].map(h=><th key={h} style={{ padding:"10px 16px", textAlign:"left", fontWeight:700, color:"#64748b", fontSize:11, textTransform:"uppercase" }}>{h}</th>)}
            </tr></thead>
            <tbody>
              {apps.filter(a=>a.status==="APPROVED"||a.status==="DISBURSED").map(a=>(
                <tr key={a.id} style={{ borderTop:"1px solid #f1f5f9" }}>
                  <td style={{ padding:"12px 16px", fontWeight:600 }}>{a.fullName}</td>
                  <td style={{ padding:"12px 16px", color:"#64748b" }}>{a.email}</td>
                  <td style={{ padding:"12px 16px" }}><span style={{ background:"#d1fae5", color:"#065f46", borderRadius:20, padding:"3px 10px", fontSize:11, fontWeight:700 }}>{a.status}</span></td>
                  <td style={{ padding:"12px 16px" }}>
                    <button onClick={()=>resendCredentials(a.id)} style={{ padding:"5px 14px", background:"#0066cc", color:"white", border:"none", borderRadius:6, fontSize:12, fontWeight:600, cursor:"pointer" }}>Resend Credentials</button>
                  </td>
                </tr>
              ))}
              {apps.filter(a=>a.status==="APPROVED"||a.status==="DISBURSED").length===0 && (
                <tr><td colSpan={4} style={{ padding:32, textAlign:"center", color:"#94a3b8" }}>No approved applicants yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}



